var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4460f13fcfce1fadd4846fe57d30f8b4.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/883466efeccccd8cc478d374e55e8109.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c73a0fb0a38d91d7821ae6c99ae04e2e.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    